import { useEffect, useState } from "react";
import { Form, Col, Row, Modal, Button } from "antd";
import useGet from "../../../global/hooks/useGet";
import usePost from "../../../global/hooks/usePost";
import usePut from "../../../global/hooks/usePut";
import CustomInput from "../../../global/components/inputWidgets/CustomInput";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  openConfirmNotification,
  openErrorNotification,
} from "../../../global/utils/toast";
import CommonBreadcrumb from "../../../global/components/CommonBreadcrumb";
import CommonButton from "../../../global/components/CommonButton";
import CustomSelect from "../../../global/components/inputWidgets/CustomSelect";
import { getModifiedResponse } from "../../../global/utils/responseModifier";
import {
  CheckCircleOutlined,
  CloseOutlined,
  UnorderedListOutlined,
  EditOutlined,
  DeleteOutlined,
  SendOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import useDelete from "../../../global/hooks/useDelete";
import ConfirmModal from "../../../global/components/ConfirmModal";
import DealerIcon from "../../../assets/images/vectors/SideBarIcons/DealerIcon";
import { AdminInvitation } from "../../../global/components/AdminInvitation";
import AccountForm from "../../../global/components/adminInfo";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import AccountCreationModal from "../../../global/components/AccountCreationModal";
import OemIcon from "../../../assets/images/vectors/SideBarIcons/OemIcon";
import AccountIcon from "../../../assets/images/vectors/SideBarIcons/AccountIcon";
import { GlobalTable } from "../../../global/components/GlobalTable";
import { DealerAccountColumns } from "../Page/DealerAccountColumns";
import { billingTypeOptions, booleanOptions } from "../../../utils/Common";
import { SendInvitationForm } from "../../Account/Components/SendInvitationForm";

export const DealerForm = ({
  type,
  onCancel,
  isModalForm,
  setDefaultData: setAccountDefaultData,
  defaultData: accountDefaultData,
}) => {
  const loggedInUser = JSON.parse(sessionStorage.getItem("userData"));
  const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const [defaultData, setDefaultData] = useState({
    DealerNo: null,
    OemNo: null,
    CustomerNo: null,
  });

  const [hoveredRow, setHoveredRow] = useState(null);
  const [showAccountModal, setShowAccountModal] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [accountId, setAccountId] = useState(null);
  const [isSendInviteOpen, setIsSendInviteOpen] = useState(false);
  const [isInviteNestedOpen, setIsInviteNestedOpen] = useState(false);
  const [inviteModalType, setInviteModalType] = useState("");

  const [form] = Form.useForm();
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const hasDealerUrl = location.pathname.includes("dealer");
  const url =
    id && hasDealerUrl
      ? `${process.env.REACT_APP_API_URL}/api/dealers/${id}/`
      : null;
  const postUrl = `${process.env.REACT_APP_API_URL}/api/dealers/`;
  // const putUrl = `${process.env.REACT_APP_API_URL}/api/dealers/${id}/`;
  // const deleteUrl = `${process.env.REACT_APP_API_URL}/api/dealers/${id}/`;
  // const optionUrl = `${process.env.REACT_APP_API_URL}/api/accounts/options/`;
  const dealerOptionUrl = `${process.env.REACT_APP_API_URL}/api/dealers/options/`;
  // const licenseParams = {
  //   limit: 20,
  //   sort_by: "LicenseNo",
  //   order: "asc",
  // };
  // const licenseQuery = new URLSearchParams(licenseParams).toString();
  // const licenseUrl = [1, 2, 3, 4, 5, 6].includes(loggedInUser?.role_value)
  //   ? `${process.env.REACT_APP_API_URL}/api/licenses/?${licenseQuery}`
  //   : null;
  // const {
  //   data: licenseData,
  //   loading: licenseDataLoading,
  //   error: licenseDataError,
  // } = useGet(licenseUrl);
  // const licenseOptions =
  //   licenseData?.data?.map((item) => ({
  //     label: item.LicenseName,
  //     value: item.LicenseNo,
  //   })) || [];

  const {
    data: dealerOptionsData,
    loading: dealerOptionsLoading,
    error: dealerOptionsError,
  } = useGet(dealerOptionUrl);

  const acountAdmin =
    type === "info" && id
      ? `${process.env.REACT_APP_API_URL}/api/accounts/?limit=100&AccountTypeIds=7,8,9&DealerNo=${id}`
      : null;

  const {
    data: adminData,
    loading: adminDataLoading,
    refetch: adminDataRefetch,
  } = useGet(acountAdmin);
  const deleteAdminUrl = `${process.env.REACT_APP_API_URL}/api/accounts/bulk-delete/`;
  const {
    data: deletedAdminData,
    loading: deletedAdminDataLoading,
    error: deletedAdminDataError,
    // deleteData,
    deleteMultiple,
  } = useDelete(deleteAdminUrl);

  const adminInfo =
    adminData?.data?.map((item) => ({ ...item, key: item.AccountNo })) || [];

  const { data, loading, error, refetch } = useGet(url);
  const { DealerNo, OemNo } = (data && data.data) || {};

  // const {
  //   data: optionData,
  //   loading: optionDataLoading,
  //   error: optionDataError,
  //   refetch: optionDataRefetch,
  // } = useGet(optionUrl);

  const modifiedOems = getModifiedResponse(dealerOptionsData, "oems");
  const modifiedGroups = getModifiedResponse(dealerOptionsData, "groups");
  const modifiedLicenseOptions = getModifiedResponse(
    dealerOptionsData,
    "licenses",
  );
  // const modifiedBillingCycles = getModifiedResponse(optionData, "bill_cycles");
  // const modifiedAutoBilling = getModifiedResponse(optionData, "auto_billings");

  const {
    data: postData,
    loading: postLoading,
    error: postError,
    postData: postAction,
  } = usePost(postUrl);
  const {
    data: putData,
    loading: putLoading,
    error: putError,
    putData: putAction,
  } = usePut(url);
  const {
    data: deletedData,
    loading: deletedDataLoading,
    error: deletedDataError,
    deleteData,
  } = useDelete(url);

  const onFinish = async (values) => {
    const modValues = {
      ...values,
      MaxAccount: Number(values.MaxAccount) || undefined,
      // Discount:
      //   typeof values.Discount === "string"
      //     ? parseInt(values.Discount)
      //     : undefined,
    };
    try {
      if (id && !isModalForm) {
        if (loggedInUser?.role_value === 4 || loggedInUser?.role_value === 5) {
          const modifiedValues = {
            ...modValues,
            OemNo: loggedInUser?.oem_no,
          };
          putAction(modifiedValues);
        } else {
          await putAction(modValues);
        }
      } else {
        if (loggedInUser?.role_value === 4 || loggedInUser?.role_value === 5) {
          const modifiedValues = {
            ...modValues,
            OemNo: loggedInUser?.oem_no,
          };
          postAction(modifiedValues);
        } else {
          await postAction(modValues);
        }
      }
    } catch (error) {
      openErrorNotification("Something went wrong.");

      console.log(error);
    }
  };

  const onReset = () => {
    // form.resetFields();
    onCancel ? onCancel() : navigate(-1);
  };

  const onDeleteConfirm = async () => {
    try {
      if (selectedRowKeys.length) {
        await deleteMultiple({ ids: selectedRowKeys });
      } else {
        await deleteData();
      }
    } catch (error) {
      openErrorNotification("Something went wrong.");
    }
    setShowModal(false);
  };

  // Set default field value
  // useEffect(() => {
  //   if (!id) {
  //     form.setFieldsValue({
  //       OemNo: modifiedOems[0]?.value,
  //     });
  //   }
  // }, [modifiedOems]);

  useEffect(() => {
    if (!id && [1, 2, 3].includes(loggedInUser?.role_value)) {
      form.setFieldsValue({
        MaxAccount: 5,
      });
    }
    if (!id && [1, 2, 3, 4, 5, 6].includes(loggedInUser?.role_value)) {
      form.setFieldsValue({
        Guest: 0,
      });
    }
    if (!id) {
      // form.setFieldValue("Discount", 0);
      form.setFieldValue("AutoBilling", 0);

      form.setFieldValue("BillingType", 1);
      form.setFieldValue("OnSiteRegister", 0);
      form.setFieldValue("CloudSite", 0);
      if (modifiedGroups.length > 0) {
        form.setFieldValue("GroupNo", modifiedGroups[0]?.value);
      }
    }
  }, [id, modifiedGroups]);

  useEffect(() => {
    if (id) return;
    if (![1, 2, 3, 4, 5, 6].includes(loggedInUser?.role_value)) return;
    const licenses = getModifiedResponse(dealerOptionsData, "licenses");
    const firstVal = licenses[0]?.value;
    if (firstVal === undefined || firstVal === null) return;
    const current = form.getFieldValue("LicenseNo");
    if (current !== undefined && current !== null && current !== "") return;
    form.setFieldValue("LicenseNo", firstVal);
  }, [id, dealerOptionsData, loggedInUser?.role_value, form]);

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    fixed: true,
  };
  const onRow = (record, rowIndex) => {
    return {
      onClick: (event) => {},
    };
  };

  useEffect(() => {
    if (!id || loading) return;
    const getAccountInfoById = () => {
      try {
        form.resetFields();
        if (data?.data) {
          form.setFieldsValue({
            OemNo: data?.data?.OemNo,
            DealerName: String(data.data.DealerName),
            DealerDesc: data.data.DealerDesc
              ? String(data.data.DealerDesc)
              : "",
            BillingType: data.data.BillingType,
            AutoBilling: data.data.AutoBilling,
            MaxAccount: data.data.MaxAccount,
            GroupNo: data.data.GroupNo,
            CloudSite: data.data.CloudSite,
            OnSiteRegister: data.data.OnSiteRegister,
            // Discount: data.data.Discount,
            LicenseNo: data.data.LicenseNo || undefined,
            // Guest: data.data.Guest,
          });
        } else {
          console.warn("No data found for the given ID");
        }
      } catch (error) {
        if (!loading) {
          openErrorNotification("Error fetching data!");
        }
      }
    };

    getAccountInfoById();
  }, [id, data, loading, form, type]);

  //toat for create
  useEffect(() => {
    if (postError) {
      openErrorNotification(
        postError?.response?.data?.message || "Something went wrong",
      );
    } else if (!postLoading && !postError && postData) {
      openConfirmNotification("Success");
      setAccountDefaultData &&
        setAccountDefaultData((prev) => {
          return {
            ...prev,
            DealerNo: postData?.data?.DealerNo,
            CustomerNo: null,
          };
        });
      setTimeout(() => {
        isModalForm
          ? onCancel()
          : navigate(
              postData?.data?.DealerNo
                ? `/dealer/info/${postData?.data?.DealerNo}`
                : -1,
            );
      }, 200);
    }
  }, [postError, postData, postLoading]);

  //toat for update
  useEffect(() => {
    if (putError) {
      openErrorNotification(
        putError?.response?.data?.message || "Something went wrong",
      );
    } else if (!putLoading && !putError && putData) {
      openConfirmNotification("Success");
      refetch();
      setTimeout(() => {
        navigate(-1);
      }, 200);
    }
  }, [putData, putLoading, putError]);

  //toast for delete
  useEffect(() => {
    if (deletedData && !deletedDataError) {
      openConfirmNotification("Success");
      // refetch();
      navigate("/dealer");
    } else if (deletedDataError) {
      openErrorNotification(
        deletedDataError?.response?.data?.message || "Something went wrong",
      );
    } else {
      return;
    }
  }, [deletedData, deletedDataError]);

  useEffect(() => {
    if (deletedAdminData && !deletedAdminDataError) {
      openConfirmNotification("Success");
      // refetch();
      adminDataRefetch();
    } else if (deletedAdminDataError) {
      openErrorNotification(
        deletedAdminDataError?.response?.data?.message ||
          "Something went wrong",
      );
    }
  }, [deletedAdminData, deletedAdminDataError]);

  useEffect(() => {
    if (accountDefaultData) {
      form.setFieldsValue(accountDefaultData);
    }
  }, [accountDefaultData]);

  //sent admin invitation
  const handleInvitation = (e) => {
    setIsModalOpen(true);
  };

  const breadcrumbItems = [
    {
      label: "Dealer",
      href: "/dealer",
    },
    {
      label: id ? (type === "info" ? "Information" : "Edit") : "Add",
      href: id
        ? type === "info"
          ? `/dealer/info/${id}`
          : `/dealer/edit/${id}`
        : "/dealer/add",
    },
  ];

  const buttonsData =
    type === "info"
      ? [
          !adminInfo && {
            label: "Dealer Invitation",
            icon: <SendOutlined />,
            onClick: handleInvitation,
          },
          {
            label: "Edit",
            icon: <EditOutlined />,
            onClick: () => {
              navigate(`/dealer/edit/${id}`);
            },
          },
          {
            label: "Delete",
            icon: <DeleteOutlined />,
            onClick: () => {
              setShowModal(true);
            },
          },
          {
            label: "List",
            icon: <UnorderedListOutlined />,
            onClick: () => {
              navigate("/dealer");
            },
          },
        ].filter(Boolean)
      : [
          {
            label: "Apply",
            icon: <CheckCircleOutlined />,
            onClick: () => form.submit(),
          },
          {
            label: "Cancel",
            icon: <CloseOutlined />,
            onClick: onReset,
          },
        ];

  const accountButtonsData = [
    {
      label: "Invite",
      icon: <SendOutlined />,
      onClick: () => setIsSendInviteOpen(true),
    },
    {
      label: "Add",
      icon: <PlusOutlined />,
      onClick: () => {
        setShowAccountModal(true);
      },
    },
    {
      label: "Delete",
      icon: <DeleteOutlined />,
      disabled: selectedRowKeys.length === 0,
      onClick: () => {
        setShowModal(true);
      },
    },
  ];

  const handleCreateNew = (type) => {
    setModalType(type);
    setIsOpenModal(true);
  };
  useEffect(() => {
    // optionDataRefetch();
    if (
      defaultData?.OemNo ||
      defaultData?.DealerNo ||
      defaultData?.CustomerNo
    ) {
      form.setFieldsValue(defaultData);
    } else if (
      accountDefaultData?.OemNo ||
      accountDefaultData?.DealerNo ||
      accountDefaultData?.CustomerNo
    ) {
      form.setFieldsValue(accountDefaultData);
    }
  }, [defaultData, accountDefaultData]);

  return (
    <>
      <AccountCreationModal
        isOpenModal={isOpenModal}
        modalType={modalType}
        setIsOpenModal={setIsOpenModal}
        setDefaultData={setDefaultData}
        defaultData={defaultData}
        setModalType={setModalType}
        isModal={true}
        isModalForm={true}
        title={
          <div className="flex items-center bg-gray-200 p-2 rounded-md">
            {modalType === "OEM" ? (
              <OemIcon className="text-[15px] text-black ml-1" />
            ) : null}
            <span className="text-[14px] font-[Poppins] text-black  ml-2">
              {isOpenModal ? `Add ${modalType}` : "Send Invitation"}
            </span>
          </div>
        }
      />
      <Form
        validateTrigger={"onChange"}
        form={form}
        onFinish={onFinish}
        scrollToFirstError
        layout={"vertical"}
        autoComplete={"off"}
      >
        <div>
          {!isModalForm && (
            <div className="pb-4 sticky -mt-4 pt-[6px] top-[55px] z-10 bg-[#f4f5f9]">
              <CommonBreadcrumb breadcrumbItems={breadcrumbItems}>
                <CommonButton buttonsData={buttonsData} />
              </CommonBreadcrumb>
            </div>
          )}
          {
            <div
              className={`bg-white overflow-hidden ${
                isModalForm ? "" : "border rounded-[4px]"
              }`}
            >
              {!isModalForm && (
                <div className="flex items-center bg-gray-200 p-2.5">
                  <DealerIcon className="text-[18px] text-black " />
                  <span className="text-[.935rem] text-black font-['Poppins'] ml-2 ">
                    Dealer
                  </span>
                </div>
              )}
              <div className="px-2 pt-1 pb-3">
                <Row gutter={[16, 8]}>
                  <Col
                    xs={!isModalForm && 24}
                    sm={!isModalForm && 24}
                    md={!isModalForm && 12}
                    lg={!isModalForm && 12}
                    xl={!isModalForm && 12}
                    span={24}
                  >
                    <CustomInput
                      label="Name"
                      name="DealerName"
                      disabled={type === "info"}
                      required
                      loading={loading}
                    />
                  </Col>
                  {/* </Row>
                  <Row gutter={[16, 16]}> */}
                  <Col
                    xs={!isModalForm && 24}
                    sm={!isModalForm && 24}
                    md={!isModalForm && 12}
                    lg={!isModalForm && 12}
                    xl={!isModalForm && 12}
                    span={24}
                  >
                    <CustomInput
                      label="Description"
                      name="DealerDesc"
                      disabled={type === "info"}
                      loading={loading}
                    />
                  </Col>
                  {/* {[1, 2, 3, 4, 5, 6].includes(loggedInUser?.role_value) && (
                    <Col
                      xs={!isModalForm && 24}
                      sm={!isModalForm && 24}
                      md={!isModalForm && 12}
                      lg={!isModalForm && 12}
                      xl={!isModalForm && 12}
                      span={24}
                    >
                      <CustomSelect
                        label="Guest"
                        name="Guest"
                        options={[
                          { label: "Yes", value: 1 },
                          { label: "No", value: 0 },
                        ]}
                        placeholder="Please select"
                        disabled={type === "info"}
                        allowClear={false}
                      />
                    </Col>
                  )} */}
                  {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomSelect
                        label="Billing Cycle"
                        name="BillingCycle"
                        options={modifiedBillingCycles}
                        placeholder="Please select"
                        disabled={type === "info"}
                        required
                      />
                    </Col> */}
                  {/* </Row>
                  <Row gutter={[16, 16]}> */}
                  {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomSelect
                        label="Auto Billing"
                        name="AutoBilling"
                        options={modifiedAutoBilling}
                        placeholder="Please select"
                        disabled={type === "info"}
                        required
                      />
                    </Col> */}
                  <Col
                    xs={!isModalForm && 24}
                    sm={!isModalForm && 24}
                    md={!isModalForm && 12}
                    lg={!isModalForm && 12}
                    xl={!isModalForm && 12}
                    span={24}
                  >
                    <CustomSelect
                      label="Group"
                      name="GroupNo"
                      options={modifiedGroups}
                      placeholder="Please select"
                      disabled={type === "info"}
                    />
                  </Col>
                  {[1, 2, 3].includes(loggedInUser?.role_value) && (
                    <Col
                      xs={!isModalForm && 24}
                      sm={!isModalForm && 24}
                      md={!isModalForm && 12}
                      lg={!isModalForm && 12}
                      xl={!isModalForm && 12}
                      span={24}
                    >
                      <CustomInput
                        label="Max Account"
                        name="MaxAccount"
                        disabled={type === "info"}
                        // required
                        type="number"
                        loading={loading}
                      />
                    </Col>
                  )}

                  {/* <Col
                    xs={!isModalForm && 24}
                    sm={!isModalForm && 24}
                    md={!isModalForm && 12}
                    lg={!isModalForm && 12}
                    xl={!isModalForm && 12}
                    span={24}
                  >
                    <CustomInput
                      label="Discount"
                      name="Discount"
                      className="discount-percent-input"
                      placeholder="Please select"
                      disable={type === "info"}
                      type="number"
                      min={0}
                      max={100}
                      postfix="%"
                      rules={[
                        {
                          validator: (_, value) => {
                            if (
                              value === undefined ||
                              value === null ||
                              value === ""
                            ) {
                              return Promise.resolve();
                            }
                            const num = Number(value);
                            if (!Number.isNaN(num) && num <= 100) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error("Discount cannot be more than 100%"),
                            );
                          },
                        },
                      ]}
                      loading={loading}
                    />
                  </Col> */}
                  <Col
                    xs={!isModalForm && 24}
                    sm={!isModalForm && 24}
                    md={!isModalForm && 12}
                    lg={!isModalForm && 12}
                    xl={!isModalForm && 12}
                    span={24}
                  >
                    <CustomSelect
                      label="Billing Type"
                      name="BillingType"
                      options={billingTypeOptions}
                      placeholder="Please select"
                      disabled={type === "info"}
                      allowClear={false}
                      loading={loading}
                      required
                    />
                  </Col>
                  <Col
                    xs={!isModalForm && 24}
                    sm={!isModalForm && 24}
                    md={!isModalForm && 12}
                    lg={!isModalForm && 12}
                    xl={!isModalForm && 12}
                    span={24}
                  >
                    <CustomSelect
                      label="Auto Billing"
                      name="AutoBilling"
                      options={booleanOptions}
                      placeholder="Please select"
                      disabled={type === "info"}
                      allowClear={false}
                      loading={loading}
                    />
                  </Col>
                  <Col
                    xs={!isModalForm && 24}
                    sm={!isModalForm && 24}
                    md={!isModalForm && 12}
                    lg={!isModalForm && 12}
                    xl={!isModalForm && 12}
                    span={24}
                  >
                    <CustomSelect
                      label="Cloud Site"
                      name="CloudSite"
                      options={booleanOptions}
                      placeholder="Please select"
                      disabled={type === "info"}
                      allowClear={false}
                      loading={loading}
                    />
                  </Col>
                  <Col
                    xs={!isModalForm && 24}
                    sm={!isModalForm && 24}
                    md={!isModalForm && 12}
                    lg={!isModalForm && 12}
                    xl={!isModalForm && 12}
                    span={24}
                  >
                    <CustomSelect
                      label="On Site Register"
                      name="OnSiteRegister"
                      options={booleanOptions}
                      placeholder="Please select"
                      disabled={type === "info"}
                      allowClear={false}
                      loading={loading}
                    />
                  </Col>

                  {[1, 2, 3, 4, 5, 6].includes(loggedInUser?.role_value) && (
                    <Col
                      xs={!isModalForm && 24}
                      sm={!isModalForm && 24}
                      md={!isModalForm && 12}
                      lg={!isModalForm && 12}
                      xl={!isModalForm && 12}
                      span={24}
                    >
                      <CustomSelect
                        label="License"
                        name="LicenseNo"
                        options={modifiedLicenseOptions}
                        placeholder="Please select"
                        disabled={type === "info"}
                        // required
                        // handleCreateNew={handleCreateNew}
                        type={"License"}
                        loading={loading}
                      />
                    </Col>
                  )}

                  {![4, 5, 6].includes(loggedInUser?.role_value) && (
                    <Col
                      xs={!isModalForm && 24}
                      sm={!isModalForm && 24}
                      md={!isModalForm && 12}
                      lg={!isModalForm && 12}
                      xl={!isModalForm && 12}
                      span={24}
                    >
                      {/* <CustomSelect
                        label="OEM"
                        name="OemNo"
                        options={modifiedOems}
                        placeholder="Please select"
                        disabled={type === "info"}
                        required
                      /> */}
                      <CustomSelect
                        label="OEM"
                        name="OemNo"
                        options={modifiedOems}
                        disabled={type === "info" || accountDefaultData?.OemNo}
                        placeholder="Please select"
                        onChange={(value) => {
                          setDefaultData((prev) => ({
                            ...prev,
                            OemNo: value,
                            DealerNo: "",
                          }));

                          // setSelectedOemNo(value);
                          form.setFieldsValue({
                            DealerNo: "",
                          });
                        }}
                        required
                        handleCreateNew={
                          accountDefaultData?.OemNo ? null : handleCreateNew
                        }
                        type={"OEM"}
                        loading={loading}
                      />
                    </Col>
                  )}
                </Row>
              </div>
            </div>
          }
        </div>
      </Form>
      {isModalForm && (
        <div className="flex justify-center space-x-2 mt-2.5">
          <Button
            type="primary"
            className="mr-2 min-w-[104px] h-[30px] py-1 px-[10px] font-medium flex items-center "
            onClick={() => form.submit()}
          >
            <IoIosCheckmarkCircleOutline className="!text-[14px] font-medium" />
            <span className="">Apply</span>
          </Button>
          <Button className="reset-button" onClick={onReset}>
            <CloseOutlined />
            <span className="">Cancel</span>
          </Button>
        </div>
      )}
      {type === "info" && (
        <>
          <div className="flex justify-between items-center my-2">
            <div className="flex">
              <span className="mr-2 text-[18px] text-black">
                <AccountIcon />
              </span>
              <span className="text-[.935rem] text-black font-['Poppins']">
                Dealer Accounts
              </span>
            </div>
            <div className="flex justify-end mb-2">
              <CommonButton buttonsData={accountButtonsData} />
            </div>
          </div>
          <>
            <GlobalTable
              columns={DealerAccountColumns(
                hoveredRow,
                setShowModal,
                setSelectedRowKeys,
                setAccountId,
                setShowAccountModal,
              )}
              dataSource={adminInfo}
              rowSelection={rowSelection}
              // onRow={onRow}
              onRow={(record, rowIndex) => {
                return {
                  onMouseEnter: () => setHoveredRow(rowIndex),
                  onMouseLeave: () => setHoveredRow(null),
                  ...onRow?.(record, rowIndex),
                };
              }}
              loading={adminDataLoading}
            />
          </>
        </>
      )}
      {/* {adminInfo && (
        <AccountForm
          adminInfo={adminInfo}
          title="Dealer Admin"
          icon={<DealerIcon />}
          type={type}
        />
      )} */}
      <AccountCreationModal
        isOpenModal={showAccountModal && accountId === null}
        modalType={"AccountCreate"}
        setIsOpenModal={setShowAccountModal}
        defaultData={{
          OemNo: form.getFieldValue("OemNo"),
          DealerNo: Number(id),
          // CustomerNo: Number(id),
        }}
        disbaleDealerField={true}
        isModal={true}
        isModalForm={true}
        refetch={adminDataRefetch}
        title={
          <div className="flex items-center bg-gray-200 p-2 rounded-md">
            <AccountIcon className="text-[15px] text-black ml-1" />
            <span className="text-[14px] font-[Poppins] text-black  ml-2">
              Add Account
            </span>
          </div>
        }
      />
      <AccountCreationModal
        isOpenModal={showAccountModal && accountId !== null}
        modalType={"AccountEdit"}
        setIsOpenModal={setShowAccountModal}
        defaultData={{
          OemNo: form.getFieldValue("OemNo"),
          DealerNo: Number(id),
          // CustomerNo: Number(id),
          AccountNo: accountId,
        }}
        isModal={true}
        // isModalForm={true}
        refetch={adminDataRefetch}
        title={
          <div className="flex items-center bg-gray-200 p-2 rounded-md">
            <AccountIcon className="text-[15px] text-black ml-1" />
            <span className="text-[14px] font-[Poppins] text-black  ml-2">
              Edit Account
            </span>
          </div>
        }
        setAccountId={setAccountId}
      />

      <ConfirmModal
        showModal={showModal}
        setShowModal={setShowModal}
        onDeleteConfirm={onDeleteConfirm}
      />
      <Modal
        title={
          <div className="flex items-center bg-gray-200 p-2 rounded-md">
            <SendOutlined className="text-[15px] text-black  ml-1" />
            <span className="text-[14px] font-[Poppins]   ml-2">
              Send Invitation
            </span>
          </div>
        }
        open={isModalOpen}
        closable={false}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width={580}
        centered
        destroyOnClose
      >
        <AdminInvitation
          payload={{ DealerNo, OemNo, AccountType: 7 }}
          setIsModalOpen={setIsModalOpen}
        />
      </Modal>
      <Modal
        afterClose={() => setInviteModalType("")}
        destroyOnClose={true}
        title={
          <div className="flex items-center bg-gray-200 p-2 rounded-md">
            <SendOutlined className="text-[15px] text-black ml-1" />
            <span className="text-[14px] font-[Poppins] text-black ml-2">
              {isInviteNestedOpen
                ? `Add ${inviteModalType}`
                : "Send Invitation"}
            </span>
          </div>
        }
        open={isSendInviteOpen}
        closable={false}
        onCancel={() => setIsSendInviteOpen(false)}
        footer={null}
        width={580}
        centered
      >
        <SendInvitationForm
          setIsModalOpen={(val) => {
            setIsSendInviteOpen(val);
            if (!val) adminDataRefetch();
          }}
          isOpenModal={isInviteNestedOpen}
          setIsOpenModal={setIsInviteNestedOpen}
          setModalType={setInviteModalType}
          modalType={inviteModalType}
          isModalOpen={isSendInviteOpen}
          lockedHierarchy={{
            OemNo: OemNo || form.getFieldValue("OemNo"),
            DealerNo: Number(id),
          }}
          accountTypeIds={[7, 8, 9]}
        />
      </Modal>
    </>
  );
};
